import gql from 'graphql-tag';

export const GetCompanySettingsData = gql`
	query GetCompanyData($companyId: ID!) {
		getCompanyData(companyId: $companyId) {
			id
			name
			defaultBonusAmount
			contactIncentiveBonus
			brandColor
			websiteUrl
			sendAdminNotificationsOnReferral
			sendAdminNotificationsOnInternalCandidatesFound
			referralBonusWaitingPeriod
			referralBonusNotificationRecipients
			dashboardReferralPolicyText
			bonusEarnedNote
			allowSelfReferrals
			allowInternalMobility
			internalMobilityImage {
				bucket
				region
				key
			}
			dateCreated
			disableSmartReferrals
			disableSAMLLogin
			disableClaimYourAccountLogin
			disableShareLink
			disableNewReferralSMSNotification
			confirmCompliance
			ssoGoogleDomain
			confirmContactEmails
			theme
			symbol {
				bucket
				region
				key
			}
			background {
				bucket
				region
				key
			}
			errorImage {
				bucket
				region
				key
			}
			whiteLabel
			enableGeneralReferrals
			enableExtendedNetwork
			enableCareerProfile
			referralStatus
			referralCustomStatuses
			referralQuestions {
				id
				companyId
				questions
				active
				isCandidate
				sortOrder
				isInterested
				isGeneral
				subCompanyId
			}
			recognitionSettings {
				allowRecognitionsForAccountClaims
				allowSelfNominations
				recognitionAnnouncementText
				recognitionCategories
				recognitionCustomTitle
				recognitionHashtags
				requireBadgeSelection
				requireBadgeAssignmentMessage
				customModal {
					title
					content
					isEnabled
					showEachLogin
				}
				hideRecognitionSocialShare
				hideRecognitionLeaderboard
				hideAllRecognitionsManager
				catalogOnlyGroupedByCategory
				customSendRecognitionBoxText
				customSendToPeerText
				disableRecHub
				disableNominations
				disableReplies
				disableReplyNotifications
				displayPointsAsCurrency
				recognitionPointsCurrency
				notificationOnApprovalDecision
				allowAdminBalanceOverrides
				rewardsEarnedMechanism
				baseSnappyBudget
				nominatedRecognitionsCostPoints
				enableManagerSendForm
				requireJustification
				requireAdminApproval
				assignSnappyRewardToRecognition
				tieredRewardsCampaign {
					id
					name
					description
					snappyGrantId
					snappyGrant {
						id
						externalSnappyId
						snappyCampaignId
						name
						description
						costInCurrency
					}
					unlockConditionType
					unlockConditionAmount
				}
				milestoneColorMap {
					years
					color
				}
				milestoneClaimExpiryDays
				milestoneClaimModalTitle
				milestoneClaimModalMessage
			}
			allowSelfReferralsInternalLink
			disableReferrals
			pointsSettings
			hideBonus
			hideShareLinkForDepartment
			hideShareLinkNoPublicUrl
			hideDateCreatedJobDetails
			hideSubcompanyOnAcceptancePage
			hideSubcompanyOnJobs
			hidePaymentInfoJobCard
			subCompanyLabel
			hideBonusFilterOnBrowseJobs
			labelDepartment
			defaultLocation
			onboarding
			labelSocialShare
			showPoweredByErin
			ownershipSettings
			helpUrl
			privacyUrl
			termsUrl
			linkUrl
			linkName
			customGeneralModal
			analyticsCardInputValues
			gifIds
			metabaseReports {
				id
				label
				reportId
				reportType
			}
		}
	}
`;
